// extracted by mini-css-extract-plugin
module.exports = {"Section":"Section_Section__CqcNT","Title":"Section_Title__3JdV3","ContentWrapper":"Section_ContentWrapper__H17GO"};